/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OwnerQrPosterRouteImport } from './routes/owner-qr-poster'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as UserRouteRouteImport } from './routes/user/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserIndexRouteImport } from './routes/user/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as UserChangePasswordRouteImport } from './routes/user/change-password'
import { Route as AdminWorkersRouteImport } from './routes/admin/workers'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminUnitsRouteImport } from './routes/admin/units'
import { Route as AdminTeamRouteImport } from './routes/admin/team'
import { Route as AdminSubmissionsRouteImport } from './routes/admin/submissions'
import { Route as AdminRemindersRouteImport } from './routes/admin/reminders'
import { Route as AdminOwnersRouteImport } from './routes/admin/owners'
import { Route as AdminMessageLogRouteImport } from './routes/admin/message-log'
import { Route as AdminFormDetailsRouteImport } from './routes/admin/form-details'
import { Route as AdminEntryLogRouteImport } from './routes/admin/entry-log'
import { Route as AdminAuditLogsRouteImport } from './routes/admin/audit-logs'
import { Route as PublicSubmitRouteImport } from './routes/_public.submit'
import { Route as PublicResetPasswordRouteImport } from './routes/_public.reset-password'
import { Route as PublicEditRequestRouteImport } from './routes/_public.edit-request'
import { Route as AuthUserResetPasswordRouteImport } from './routes/_auth.user.reset-password'
import { Route as AuthUserLoginRouteImport } from './routes/_auth.user.login'
import { Route as AuthUserForgotPasswordRouteImport } from './routes/_auth.user.forgot-password'
import { Route as AuthAdminSetupRouteImport } from './routes/_auth.admin.setup'
import { Route as AuthAdminLoginRouteImport } from './routes/_auth.admin.login'
import { Route as AuthAdminForgotPasswordRouteImport } from './routes/_auth.admin.forgot-password'

const OwnerQrPosterRoute = OwnerQrPosterRouteImport.update({
  id: '/owner-qr-poster',
  path: '/owner-qr-poster',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const UserRouteRoute = UserRouteRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserIndexRoute = UserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const UserChangePasswordRoute = UserChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => UserRouteRoute,
} as any)
const AdminWorkersRoute = AdminWorkersRouteImport.update({
  id: '/workers',
  path: '/workers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUnitsRoute = AdminUnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTeamRoute = AdminTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSubmissionsRoute = AdminSubmissionsRouteImport.update({
  id: '/submissions',
  path: '/submissions',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRemindersRoute = AdminRemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOwnersRoute = AdminOwnersRouteImport.update({
  id: '/owners',
  path: '/owners',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMessageLogRoute = AdminMessageLogRouteImport.update({
  id: '/message-log',
  path: '/message-log',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFormDetailsRoute = AdminFormDetailsRouteImport.update({
  id: '/form-details',
  path: '/form-details',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminEntryLogRoute = AdminEntryLogRouteImport.update({
  id: '/entry-log',
  path: '/entry-log',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const PublicSubmitRoute = PublicSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicEditRequestRoute = PublicEditRequestRouteImport.update({
  id: '/edit-request',
  path: '/edit-request',
  getParentRoute: () => PublicRoute,
} as any)
const AuthUserResetPasswordRoute = AuthUserResetPasswordRouteImport.update({
  id: '/user/reset-password',
  path: '/user/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserLoginRoute = AuthUserLoginRouteImport.update({
  id: '/user/login',
  path: '/user/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUserForgotPasswordRoute = AuthUserForgotPasswordRouteImport.update({
  id: '/user/forgot-password',
  path: '/user/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminSetupRoute = AuthAdminSetupRouteImport.update({
  id: '/admin/setup',
  path: '/admin/setup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminLoginRoute = AuthAdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminForgotPasswordRoute = AuthAdminForgotPasswordRouteImport.update({
  id: '/admin/forgot-password',
  path: '/admin/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/user': typeof UserRouteRouteWithChildren
  '/owner-qr-poster': typeof OwnerQrPosterRoute
  '/edit-request': typeof PublicEditRequestRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/submit': typeof PublicSubmitRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/entry-log': typeof AdminEntryLogRoute
  '/admin/form-details': typeof AdminFormDetailsRoute
  '/admin/message-log': typeof AdminMessageLogRoute
  '/admin/owners': typeof AdminOwnersRoute
  '/admin/reminders': typeof AdminRemindersRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/units': typeof AdminUnitsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workers': typeof AdminWorkersRoute
  '/user/change-password': typeof UserChangePasswordRoute
  '/admin/': typeof AdminIndexRoute
  '/user/': typeof UserIndexRoute
  '/admin/forgot-password': typeof AuthAdminForgotPasswordRoute
  '/admin/login': typeof AuthAdminLoginRoute
  '/admin/setup': typeof AuthAdminSetupRoute
  '/user/forgot-password': typeof AuthUserForgotPasswordRoute
  '/user/login': typeof AuthUserLoginRoute
  '/user/reset-password': typeof AuthUserResetPasswordRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/owner-qr-poster': typeof OwnerQrPosterRoute
  '/edit-request': typeof PublicEditRequestRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/submit': typeof PublicSubmitRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/entry-log': typeof AdminEntryLogRoute
  '/admin/form-details': typeof AdminFormDetailsRoute
  '/admin/message-log': typeof AdminMessageLogRoute
  '/admin/owners': typeof AdminOwnersRoute
  '/admin/reminders': typeof AdminRemindersRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/units': typeof AdminUnitsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workers': typeof AdminWorkersRoute
  '/user/change-password': typeof UserChangePasswordRoute
  '/admin': typeof AdminIndexRoute
  '/user': typeof UserIndexRoute
  '/admin/forgot-password': typeof AuthAdminForgotPasswordRoute
  '/admin/login': typeof AuthAdminLoginRoute
  '/admin/setup': typeof AuthAdminSetupRoute
  '/user/forgot-password': typeof AuthUserForgotPasswordRoute
  '/user/login': typeof AuthUserLoginRoute
  '/user/reset-password': typeof AuthUserResetPasswordRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/user': typeof UserRouteRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/owner-qr-poster': typeof OwnerQrPosterRoute
  '/_public/edit-request': typeof PublicEditRequestRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/submit': typeof PublicSubmitRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/entry-log': typeof AdminEntryLogRoute
  '/admin/form-details': typeof AdminFormDetailsRoute
  '/admin/message-log': typeof AdminMessageLogRoute
  '/admin/owners': typeof AdminOwnersRoute
  '/admin/reminders': typeof AdminRemindersRoute
  '/admin/submissions': typeof AdminSubmissionsRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/units': typeof AdminUnitsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/workers': typeof AdminWorkersRoute
  '/user/change-password': typeof UserChangePasswordRoute
  '/admin/': typeof AdminIndexRoute
  '/user/': typeof UserIndexRoute
  '/_auth/admin/forgot-password': typeof AuthAdminForgotPasswordRoute
  '/_auth/admin/login': typeof AuthAdminLoginRoute
  '/_auth/admin/setup': typeof AuthAdminSetupRoute
  '/_auth/user/forgot-password': typeof AuthUserForgotPasswordRoute
  '/_auth/user/login': typeof AuthUserLoginRoute
  '/_auth/user/reset-password': typeof AuthUserResetPasswordRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/user'
    | '/owner-qr-poster'
    | '/edit-request'
    | '/reset-password'
    | '/submit'
    | '/admin/audit-logs'
    | '/admin/entry-log'
    | '/admin/form-details'
    | '/admin/message-log'
    | '/admin/owners'
    | '/admin/reminders'
    | '/admin/submissions'
    | '/admin/team'
    | '/admin/units'
    | '/admin/users'
    | '/admin/workers'
    | '/user/change-password'
    | '/admin/'
    | '/user/'
    | '/admin/forgot-password'
    | '/admin/login'
    | '/admin/setup'
    | '/user/forgot-password'
    | '/user/login'
    | '/user/reset-password'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/owner-qr-poster'
    | '/edit-request'
    | '/reset-password'
    | '/submit'
    | '/admin/audit-logs'
    | '/admin/entry-log'
    | '/admin/form-details'
    | '/admin/message-log'
    | '/admin/owners'
    | '/admin/reminders'
    | '/admin/submissions'
    | '/admin/team'
    | '/admin/units'
    | '/admin/users'
    | '/admin/workers'
    | '/user/change-password'
    | '/admin'
    | '/user'
    | '/admin/forgot-password'
    | '/admin/login'
    | '/admin/setup'
    | '/user/forgot-password'
    | '/user/login'
    | '/user/reset-password'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/user'
    | '/_auth'
    | '/_public'
    | '/owner-qr-poster'
    | '/_public/edit-request'
    | '/_public/reset-password'
    | '/_public/submit'
    | '/admin/audit-logs'
    | '/admin/entry-log'
    | '/admin/form-details'
    | '/admin/message-log'
    | '/admin/owners'
    | '/admin/reminders'
    | '/admin/submissions'
    | '/admin/team'
    | '/admin/units'
    | '/admin/users'
    | '/admin/workers'
    | '/user/change-password'
    | '/admin/'
    | '/user/'
    | '/_auth/admin/forgot-password'
    | '/_auth/admin/login'
    | '/_auth/admin/setup'
    | '/_auth/user/forgot-password'
    | '/_auth/user/login'
    | '/_auth/user/reset-password'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  UserRouteRoute: typeof UserRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  OwnerQrPosterRoute: typeof OwnerQrPosterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/owner-qr-poster': {
      id: '/owner-qr-poster'
      path: '/owner-qr-poster'
      fullPath: '/owner-qr-poster'
      preLoaderRoute: typeof OwnerQrPosterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/': {
      id: '/user/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof UserIndexRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/user/change-password': {
      id: '/user/change-password'
      path: '/change-password'
      fullPath: '/user/change-password'
      preLoaderRoute: typeof UserChangePasswordRouteImport
      parentRoute: typeof UserRouteRoute
    }
    '/admin/workers': {
      id: '/admin/workers'
      path: '/workers'
      fullPath: '/admin/workers'
      preLoaderRoute: typeof AdminWorkersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/units': {
      id: '/admin/units'
      path: '/units'
      fullPath: '/admin/units'
      preLoaderRoute: typeof AdminUnitsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/team': {
      id: '/admin/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AdminTeamRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/submissions': {
      id: '/admin/submissions'
      path: '/submissions'
      fullPath: '/admin/submissions'
      preLoaderRoute: typeof AdminSubmissionsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/reminders': {
      id: '/admin/reminders'
      path: '/reminders'
      fullPath: '/admin/reminders'
      preLoaderRoute: typeof AdminRemindersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/owners': {
      id: '/admin/owners'
      path: '/owners'
      fullPath: '/admin/owners'
      preLoaderRoute: typeof AdminOwnersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/message-log': {
      id: '/admin/message-log'
      path: '/message-log'
      fullPath: '/admin/message-log'
      preLoaderRoute: typeof AdminMessageLogRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/form-details': {
      id: '/admin/form-details'
      path: '/form-details'
      fullPath: '/admin/form-details'
      preLoaderRoute: typeof AdminFormDetailsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/entry-log': {
      id: '/admin/entry-log'
      path: '/entry-log'
      fullPath: '/admin/entry-log'
      preLoaderRoute: typeof AdminEntryLogRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit-logs': {
      id: '/admin/audit-logs'
      path: '/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof AdminAuditLogsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_public/submit': {
      id: '/_public/submit'
      path: '/submit'
      fullPath: '/submit'
      preLoaderRoute: typeof PublicSubmitRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/edit-request': {
      id: '/_public/edit-request'
      path: '/edit-request'
      fullPath: '/edit-request'
      preLoaderRoute: typeof PublicEditRequestRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/user/reset-password': {
      id: '/_auth/user/reset-password'
      path: '/user/reset-password'
      fullPath: '/user/reset-password'
      preLoaderRoute: typeof AuthUserResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user/login': {
      id: '/_auth/user/login'
      path: '/user/login'
      fullPath: '/user/login'
      preLoaderRoute: typeof AuthUserLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/user/forgot-password': {
      id: '/_auth/user/forgot-password'
      path: '/user/forgot-password'
      fullPath: '/user/forgot-password'
      preLoaderRoute: typeof AuthUserForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/setup': {
      id: '/_auth/admin/setup'
      path: '/admin/setup'
      fullPath: '/admin/setup'
      preLoaderRoute: typeof AuthAdminSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/login': {
      id: '/_auth/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AuthAdminLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/forgot-password': {
      id: '/_auth/admin/forgot-password'
      path: '/admin/forgot-password'
      fullPath: '/admin/forgot-password'
      preLoaderRoute: typeof AuthAdminForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAuditLogsRoute: typeof AdminAuditLogsRoute
  AdminEntryLogRoute: typeof AdminEntryLogRoute
  AdminFormDetailsRoute: typeof AdminFormDetailsRoute
  AdminMessageLogRoute: typeof AdminMessageLogRoute
  AdminOwnersRoute: typeof AdminOwnersRoute
  AdminRemindersRoute: typeof AdminRemindersRoute
  AdminSubmissionsRoute: typeof AdminSubmissionsRoute
  AdminTeamRoute: typeof AdminTeamRoute
  AdminUnitsRoute: typeof AdminUnitsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminWorkersRoute: typeof AdminWorkersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAuditLogsRoute: AdminAuditLogsRoute,
  AdminEntryLogRoute: AdminEntryLogRoute,
  AdminFormDetailsRoute: AdminFormDetailsRoute,
  AdminMessageLogRoute: AdminMessageLogRoute,
  AdminOwnersRoute: AdminOwnersRoute,
  AdminRemindersRoute: AdminRemindersRoute,
  AdminSubmissionsRoute: AdminSubmissionsRoute,
  AdminTeamRoute: AdminTeamRoute,
  AdminUnitsRoute: AdminUnitsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminWorkersRoute: AdminWorkersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface UserRouteRouteChildren {
  UserChangePasswordRoute: typeof UserChangePasswordRoute
  UserIndexRoute: typeof UserIndexRoute
}

const UserRouteRouteChildren: UserRouteRouteChildren = {
  UserChangePasswordRoute: UserChangePasswordRoute,
  UserIndexRoute: UserIndexRoute,
}

const UserRouteRouteWithChildren = UserRouteRoute._addFileChildren(
  UserRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminForgotPasswordRoute: typeof AuthAdminForgotPasswordRoute
  AuthAdminLoginRoute: typeof AuthAdminLoginRoute
  AuthAdminSetupRoute: typeof AuthAdminSetupRoute
  AuthUserForgotPasswordRoute: typeof AuthUserForgotPasswordRoute
  AuthUserLoginRoute: typeof AuthUserLoginRoute
  AuthUserResetPasswordRoute: typeof AuthUserResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminForgotPasswordRoute: AuthAdminForgotPasswordRoute,
  AuthAdminLoginRoute: AuthAdminLoginRoute,
  AuthAdminSetupRoute: AuthAdminSetupRoute,
  AuthUserForgotPasswordRoute: AuthUserForgotPasswordRoute,
  AuthUserLoginRoute: AuthUserLoginRoute,
  AuthUserResetPasswordRoute: AuthUserResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicEditRequestRoute: typeof PublicEditRequestRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSubmitRoute: typeof PublicSubmitRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicEditRequestRoute: PublicEditRequestRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSubmitRoute: PublicSubmitRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  UserRouteRoute: UserRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  OwnerQrPosterRoute: OwnerQrPosterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
